import axios from 'axios'
import {AzSearchUrlBuilder} from '@azinformatica/loki'

class RelatoriosTceApiClient {

  async gerarRelatoriosTce(filtros) {
      var url = AzSearchUrlBuilder.build('api/relatorios/tce', filtros)
      return axios.get(url, { responseType: 'arraybuffer' })
  }
}

export default new RelatoriosTceApiClient()
